<template>
<!--  Desktop version-->
  <div
    v-if="!$vuetify.breakpoint.mobile && config.visible === true"
  >
<!--    Title-->
    <v-row
      style="margin: 0;"
    >
      <v-col
        style="padding-bottom: 0; font-family: 'Satoshi', sans-serif !important; font-size: 20px !important; font-weight: 500; color: #09090B;"
      >
        {{ $t('road-maintenance/aggregator.anticipated_damage') }}
      </v-col>
    </v-row>
    <div
      style="margin: 15px; padding: 16px; border: 1px solid #E5E7EB; border-radius: 16px;"
    >
      <!--    Header row-->
      <v-row
        class="v-row"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="selectAll"
            label="Naziv"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center"
          style="max-width: 140px; word-break: break-word; font-weight: 500; font-size: 16px; line-height: 24px;"
        >
          {{ $t('road-maintenance/aggregator.measure_unit') }}
        </v-col>
        <v-col
          class="d-flex align-center"
          style="font-weight: 500; font-size: 16px; line-height: 24px;"
        >
          {{ $t('road-maintenance/aggregator.material_type') }}
        </v-col>
        <v-col
          class="d-flex align-center"
          style="font-weight: 500; font-size: 16px; line-height: 24px;"
        >
          {{ $t('road-maintenance/aggregator.dimensions') }}
        </v-col>
      </v-row>

      <!--    Roadway row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.roadway"
            :label="$t('road-maintenance/excavation-service/tabs/offer/columns.pavement')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m<sup>2</sup>
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.roadway_type"
            :items="{ roadway_sidewalk_types: { data: config.dropdownValues && config.dropdownValues.roadway_sidewalk_type ? config.dropdownValues.roadway_sidewalk_type : [] } }"
            :field="{
              key: 'roadway_sidewalk_types',
              placeholder: !shouldDisableInputField('roadway') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.name ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('roadway')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.roadway_desc"
            :disabled="!(canEdit && !!formDataCopy.roadway)"
          />
        </v-col>
      </v-row>

      <!--    Sidewalk row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.sidewalk"
            :label="$t('road-maintenance/excavation-service/tabs/offer/columns.footpath')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m<sup>2</sup>
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.sidewalk_type"
            :items="{ roadway_sidewalk_types: { data: config.dropdownValues && config.dropdownValues.roadway_sidewalk_type ? config.dropdownValues.roadway_sidewalk_type : [] } }"
            :field="{
              key: 'roadway_sidewalk_types',
              placeholder: !shouldDisableInputField('sidewalk') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('sidewalk')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.sidewalk_desc"
            :disabled="!(canEdit && !!formDataCopy.sidewalk)"
          />
        </v-col>
      </v-row>

      <!--    Road shoulder row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.road_shoulder"
            :label="$t('road-maintenance/excavation-service/tabs/offer/columns.sidewalk')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m<sup>2</sup>
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.road_shoulder_type"
            :items="{ road_shoulder: { data: config.dropdownValues && config.dropdownValues.road_shoulder_type ? config.dropdownValues.road_shoulder_type : [] } }"
            :field="{
              key: 'road_shoulder',
              placeholder: !shouldDisableInputField('road_shoulder') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('road_shoulder')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.road_shoulder_desc"
            :disabled="!(canEdit && !!formDataCopy.road_shoulder)"
          />
        </v-col>
      </v-row>

      <!--    Curb row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.curb"
            :label="$t('road-maintenance/excavation-service/tabs/offer/columns.curb')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.curb_type"
            :items="{ curb: { data: config.dropdownValues && config.dropdownValues.curb_type ? config.dropdownValues.curb_type : [] } }"
            :field="{
              key: 'curb',
              placeholder: !shouldDisableInputField('curb') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('curb')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.curb_desc"
            :disabled="!(canEdit && !!formDataCopy.curb)"
          />
        </v-col>
      </v-row>

      <!--    Gutter row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.gutter"
            :label="$t('road-maintenance/excavation-service/tabs/offer/columns.canals')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.gutter_type"
            :field="{
              key: 'gutter_type',
              placeholder: !shouldDisableInputField('gutter') ? $t('road-maintenance/aggregator.enter_material_type') : '',
              options: {
                custom_display_value: (item) => {
                return item && item.name ? item.name : ''
                }
              }
            }"
            :disabled="shouldDisableInputField('gutter')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.gutter_desc"
            :disabled="!(canEdit && !!formDataCopy.gutter)"
          />
        </v-col>
      </v-row>

      <!--    Roadway markings row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.roadway_markings"
            :label="$t('road-maintenance/aggregator.roadway_markings')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          m<sup>2</sup>
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.roadway_markings_type"
            :items="{ roadway_markings: { data: config.dropdownValues && config.dropdownValues.roadway_marking_type ? config.dropdownValues.roadway_marking_type : [] } }"
            :field="{
              key: 'roadway_markings',
              placeholder: !shouldDisableInputField('roadway_markings') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('roadway_markings')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.roadway_markings_desc"
            :disabled="!(canEdit && !!formDataCopy.roadway_markings)"
          />
        </v-col>
      </v-row>

      <!--    Traffic sign row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.traffic_sign"
            :label="$t('road-maintenance/aggregator.traffic_sign')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          kom.
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.traffic_sign_type"
            :field="{
              placeholder: !shouldDisableInputField('traffic_sign') ? $t('road-maintenance/aggregator.enter_traffic_sign') : '',
              options: {
                custom_display_value: (item) => {
                  return item && item.name ? item.name : ''
                }
              }
            }"
            :disabled="shouldDisableInputField('traffic_sign')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.traffic_sign_desc"
            :disabled="!(canEdit && !!formDataCopy.traffic_sign)"
          />
        </v-col>
      </v-row>

      <!--    Road equipment row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.road_equipment"
            :label="$t('road-maintenance/aggregator.road_equipment')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          kom.
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.road_equipment_type"
            :items="{ road_equipment: { data: config.dropdownValues && config.dropdownValues.road_equipment_type ? config.dropdownValues.road_equipment_type : [] } }"
            :field="{
              key: 'road_equipment',
              placeholder: !shouldDisableInputField('road_equipment') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('road_equipment')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.road_equipment_desc"
            :disabled="!(canEdit && !!formDataCopy.road_equipment)"
          />
        </v-col>
      </v-row>

      <!--    Speed bumps row-->
      <v-row
        class="v-row"
        @dblclick="$emit('set-edit', true)"
      >
        <v-col
          style="padding: 0;"
        >
          <v-checkbox
            v-model="formDataCopy.speed_bumps"
            :label="$t('road-maintenance/aggregator.speed_bumps')"
            color="#163D73"
            :disabled="!canEdit"
          />
        </v-col>
        <v-col
          class="d-flex align-center justify-center"
          style="max-width: 120px; word-break: break-word;"
        >
          kom.
        </v-col>
        <v-col>
          <autocomplete-field
            v-model="formDataCopy.speed_bumps_type"
            :items="{ speed_bumps: { data: config.dropdownValues && config.dropdownValues.speed_bump_type ? config.dropdownValues.speed_bump_type : [] } }"
            :field="{
              key: 'speed_bumps',
              placeholder: !shouldDisableInputField('speed_bumps') ? $t('road-maintenance/aggregator.select_material_type') : '',
              fetchInitial: false
            }"
            :options="{
              custom_display_value: (value) => {
                return value && value.description ? $t(value.description) : null
              }
            }"
            :disabled="shouldDisableInputField('speed_bumps')"
          />
        </v-col>
        <v-col>
          <text-field
            v-model="formDataCopy.speed_bumps_desc"
            :disabled="!(canEdit && !!formDataCopy.speed_bumps)"
          />
        </v-col>
      </v-row>

      <!--    Note-->
      <v-row
        v-if="canEdit"
        class="v-row"
      >
        <v-col
          style="color: #EF4444; font-weight: 500; font-size: 14px; line-height: 20px; padding-left: 0; font-family: 'Satoshi', sans-serif;"
        >
          {{ $t('road-maintenance/aggregator.damages_note') }}
        </v-col>
      </v-row>
    </div>
  </div>

<!--  Mobile version-->
  <div
    v-else-if="config.visible === true"
  >
    <v-row
      v-for="(mobileDamageCard, mobileDamageCardIndex) in mobileDamageCards"
      :key="mobileDamageCardIndex"
      class="mt-6 v-row--mobile"
    >
      <v-col
        class="main-col--mobile"
      >
<!--        Card header-->
        <div
          class="card-header--mobile"
        >
          <v-row>
            <v-col>
              {{ mobileDamageCard.title.text }}
            </v-col>
            <v-col
              class="d-flex justify-end pr-1"
            >
              <v-checkbox
                v-model="formDataCopy[mobileDamageCard.title.checkboxKey]"
                :disabled="!canEdit"
                class="checkbox--mobile"
              />
            </v-col>
          </v-row>
        </div>

<!--        Header bottom line-->
        <div class="border-bottom"/>

        <div
          class="card-content-wrapper--mobile"
        >
          <div
            class="card-content-title--mobile"
          >
            <v-row>
              <v-col>
                {{ mobileDamageCard.content.title.text1 }}
              </v-col>
              <v-col
                class="d-flex justify-end"
                v-html="mobileDamageCard.content.title.text2"
              />
            </v-row>
          </div>
          <div
            class="card-content--mobile"
          >
            <v-row>
              <v-col>
                <autocomplete-field
                  v-if="mobileDamageCard.content.field1.type === 'autocomplete'"
                  v-model="formDataCopy[mobileDamageCard.content.field1.key]"
                  :items="{ [mobileDamageCard.content.field1.autocompleteKey]: { data: config.dropdownValues && config.dropdownValues[mobileDamageCard.content.field1.dropdownKey] ? config.dropdownValues[mobileDamageCard.content.field1.dropdownKey] : [] } }"
                  :field="mobileDamageCard.content.field1.config"
                  :options="mobileDamageCard.content.field1.options"
                  :disabled="!(canEdit && !!formDataCopy[mobileDamageCard.title.checkboxKey])"
                />
                <text-field
                  v-else-if="mobileDamageCard.content.field1.type === 'text'"
                  v-model="formDataCopy[mobileDamageCard.content.field1.key]"
                  :field="mobileDamageCard.content.field1.config"
                  :disabled="!(canEdit && !!formDataCopy[mobileDamageCard.title.checkboxKey])"
                />
                <text-field
                  v-else
                  v-model="formDataCopy[mobileDamageCard.content.field1.key]"
                  :field="mobileDamageCard.content.field1.config"
                  :disabled="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <text-field
                  v-model="formDataCopy[mobileDamageCard.content.field2.key]"
                  :field="mobileDamageCard.content.field2.config"
                  :disabled="!(canEdit && !!formDataCopy[mobileDamageCard.title.checkboxKey])"
                />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row
      v-if="canEdit"
      class="v-row--mobile"
    >
      <v-col
        style="color: #EF4444; font-weight: 500; font-size: 14px; line-height: 20px; font-family: 'Satoshi', sans-serif;"
      >
        {{ $t('road-maintenance/aggregator.damages_note') }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AutocompleteField from '@/global/components/view-layouts/tabs-layout/components/fields/AutocompleteField.vue'
import textField from '@/global/components/view-layouts/tabs-layout/components/fields/TextField.vue'

import { isObject } from 'lodash'
export default {
  name: 'AnticipatedDamage',

  components: {
    AutocompleteField,
    textField
  },

  props: {
    edit: {
      type: Boolean,
      default: false
    },
    createMode: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    },
    updateData: {
      type: Function,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      selectAll: false,
      formDataCopy: {},
      mobileDamageCards: [
        {
          title: {
            text: this.$t('road-maintenance/excavation-service/tabs/offer/columns.pavement'),
            checkboxKey: 'roadway'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm <sup style="top: 5px;">2</sup>'
            },
            field1: {
              type: 'autocomplete',
              key: 'roadway_sidewalk_types',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'roadway_sidewalk_types',
              dropdownKey: 'roadway_sidewalk_type'
            },
            field2: {
              type: 'text',
              key: 'roadway_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/excavation-service/tabs/offer/columns.footpath'),
            checkboxKey: 'sidewalk'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm <sup style="top: 5px;">2</sup>'
            },
            field1: {
              type: 'autocomplete',
              key: 'sidewalk_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'roadway_sidewalk_types'
            },
            field2: {
              type: 'text',
              key: 'sidewalk_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/excavation-service/tabs/offer/columns.sidewalk'),
            checkboxKey: 'road_shoulder'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm <sup style="top: 5px;">2</sup>'
            },
            field1: {
              type: 'autocomplete',
              key: 'road_shoulder_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'road_shoulder'
            },
            field2: {
              type: 'text',
              key: 'road_shoulder_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/excavation-service/tabs/offer/columns.curb'),
            checkboxKey: 'curb'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm'
            },
            field1: {
              type: 'autocomplete',
              key: 'curb_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'curb'
            },
            field2: {
              type: 'text',
              key: 'curb_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/excavation-service/tabs/offer/columns.canals'),
            checkboxKey: 'gutter'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm'
            },
            field1: {
              type: 'text',
              key: 'gutter_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                options: {
                  custom_display_value: (value) => {
                    return value && value.name ? value.name : ''
                  }
                }
              }
            },
            field2: {
              type: 'text',
              key: 'gutter_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/aggregator.roadway_markings'),
            checkboxKey: 'roadway_markings'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'm <sup style="top: 5px;">2</sup>'
            },
            field1: {
              type: 'autocomplete',
              key: 'roadway_markings_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'roadway_markings'
            },
            field2: {
              type: 'text',
              key: 'roadway_markings_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/aggregator.traffic_sign'),
            checkboxKey: 'traffic_sign'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'kom.'
            },
            field1: {
              type: 'text',
              key: 'traffic_sign_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                options: {
                  custom_display_value: (value) => {
                    return value && value.name ? value.name : null
                  }
                }
              }
            },
            field2: {
              type: 'text',
              key: 'traffic_sign_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/aggregator.road_equipment'),
            checkboxKey: 'road_equipment'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'kom.'
            },
            field1: {
              type: 'autocomplete',
              key: 'road_equipment_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'road_equipment'
            },
            field2: {
              type: 'text',
              key: 'road_equipment_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        },
        {
          title: {
            text: this.$t('road-maintenance/aggregator.speed_bumps'),
            checkboxKey: 'speed_bumps'
          },
          content: {
            title: {
              text1: this.$t('road-maintenance/aggregator.measure_unit'),
              text2: 'kom.'
            },
            field1: {
              type: 'autocomplete',
              key: 'speed_bumps_type',
              config: {
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.select_material_type'),
                label: this.$t('road-maintenance/aggregator.material_type'),
                fetchInitial: false
              },
              options: {
                custom_display_value: (value) => {
                  return value && value.description ? this.$t(value.description) : null
                }
              },
              autocompleteKey: 'speed_bumps'
            },
            field2: {
              type: 'text',
              key: 'speed_bumps_desc',
              config: {
                label: this.$t('road-maintenance/aggregator.dimensions'),
                placeholder: !this.canEdit ? '' : this.$t('road-maintenance/aggregator.enter_dimensions')
              }
            }
          }
        }
      ]
    }
  },

  computed: {
    canEdit () {
      return this.edit || this.createMode
    }
  },

  watch: {
    selectAll: {
      immediate: true,
      handler (val) {
        if (val) {
          this.updateData({
            roadway: true,
            sidewalk: true,
            road_shoulder: true,
            curb: true,
            gutter: true,
            roadway_markings: true,
            traffic_sign: true,
            road_equipment: true,
            speed_bumps: true
          })
        }
        else {
          this.updateData({
            roadway: false,
            sidewalk: false,
            road_shoulder: false,
            curb: false,
            gutter: false,
            roadway_markings: false,
            traffic_sign: false,
            road_equipment: false,
            speed_bumps: false
          })
        }
      }
    },

    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.formDataCopy = val
      }
    },

    'formData.damages': {
      immediate: true,
      deep: true,
      handler (val) {
        if (val && isObject(val)) {
          this.$set(this.formDataCopy, 'roadway', val?.roadway || false)
          this.$set(this.formDataCopy, 'roadway_type', val?.roadway_type || null)
          this.$set(this.formDataCopy, 'roadway_desc', val?.roadway_desc || null)

          this.$set(this.formDataCopy, 'sidewalk', val?.sidewalk || false)
          this.$set(this.formDataCopy, 'sidewalk_type', val?.sidewalk_type || null)
          this.$set(this.formDataCopy, 'sidewalk_desc', val?.sidewalk_desc || null)

          this.$set(this.formDataCopy, 'road_shoulder', val?.road_shoulder || false)
          this.$set(this.formDataCopy, 'road_shoulder_type', val?.road_shoulder_type || null)
          this.$set(this.formDataCopy, 'road_shoulder_desc', val?.road_shoulder_desc || null)

          this.$set(this.formDataCopy, 'curb', val?.curb || false)
          this.$set(this.formDataCopy, 'curb_type', val?.curb_type || null)
          this.$set(this.formDataCopy, 'curb_desc', val?.curb_desc || null)

          this.$set(this.formDataCopy, 'gutter', val?.gutter || false)
          this.$set(this.formDataCopy, 'gutter_type', val?.gutter_type || null)
          this.$set(this.formDataCopy, 'gutter_desc', val?.gutter_desc || null)

          this.$set(this.formDataCopy, 'roadway_markings', val?.roadway_markings || false)
          this.$set(this.formDataCopy, 'roadway_markings_type', val?.roadway_markings_type || null)
          this.$set(this.formDataCopy, 'roadway_markings_desc', val?.roadway_markings_desc || null)

          this.$set(this.formDataCopy, 'traffic_sign', val?.traffic_sign || false)
          this.$set(this.formDataCopy, 'traffic_sign_type', val?.traffic_sign_type || null)
          this.$set(this.formDataCopy, 'traffic_sign_desc', val?.traffic_sign_desc || null)

          this.$set(this.formDataCopy, 'road_equipment', val?.road_equipment || false)
          this.$set(this.formDataCopy, 'road_equipment_type', val?.road_equipment_type || null)
          this.$set(this.formDataCopy, 'road_equipment_desc', val?.road_equipment_desc || null)

          this.$set(this.formDataCopy, 'speed_bumps', val?.speed_bumps || false)
          this.$set(this.formDataCopy, 'speed_bumps_type', val?.speed_bumps_type || null)
          this.$set(this.formDataCopy, 'speed_bumps_desc', val?.speed_bumps_desc || null)
        }
      }
    }
  },

  methods: {
    shouldDisableInputField (key) {
      return !(this.canEdit && this.formDataCopy[key] === true)
    }
  }
}
</script>

<style scoped>
.main-col--mobile {
  border: 1px solid #E5E5E5;
  border-radius: 8px;
  padding: 0;
}

.card-header--mobile {
  padding: 12px;
}

.card-content-wrapper--mobile {
  padding: 12px;
}

.card-content-title--mobile {
  display: flex;
}

.card-content--mobile {
  display: flex;
  flex-direction: column;
  margin-top: 15px;
}

.border-bottom {
  border: 1px solid #E5E5E5;
}

::v-deep {
  .checkbox--mobile {
    margin: 0 !important;
    padding: 0 !important;
  }

  .checkbox--mobile .v-input__control {
    height: 20px !important;
  }

  .checkbox--mobile .v-input__control .v-selection-control {
    min-height: unset !important;
  }
}

.v-row {
  margin: 0 !important;
}

.v-row--mobile {
  margin: 20px 0 0 0 !important;
}
</style>
